// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_FACET_P_PRICE = "Cena v EUR";
export const BZ2_FILTER_PRICE_MAX = "Cena do";
export const BZ2_FILTER_PRICE_MIN = "Cena od";
